export default __webpack_public_path__ + "static/media/ios_full.38b686ad.png";